import React from 'react';
import { AlertTriangle, Check, Loader2, RotateCw } from 'lucide-react';
import { SPEICHER_TEXT, SpeicherAnzeige } from './gbuModulLogic';

/**
 * Klein und ruhig: „Speichert…", „Gespeichert", bei Fehler rot „Nicht
 * gespeichert — erneut versuchen" mit Knopf, bei unvollstaendiger Eingabe der
 * Grund. Nichts, solange nichts zu sagen ist.
 */
export const SpeicherStatus: React.FC<{
  anzeige: SpeicherAnzeige;
  fehler?: string | null;
  /** Gruende, warum (noch) nicht gespeichert werden kann. */
  gruende?: string[];
  onErneut?: () => void;
  /** Bei Fehler zusaetzlich „Neu laden" (z. B. „nicht mehr im Entwurf"). */
  onNeuLaden?: () => void;
}> = ({ anzeige, fehler, gruende, onErneut, onNeuLaden }) => {
  if (anzeige === 'ruhig') return null;
  if (anzeige === 'wartet' || anzeige === 'speichert') {
    return <span className="inline-flex items-center gap-1 text-[11px] text-slate-400"><Loader2 className="w-3 h-3 animate-spin" /> {SPEICHER_TEXT[anzeige]}</span>;
  }
  if (anzeige === 'gespeichert') {
    return <span className="inline-flex items-center gap-1 text-[11px] text-slate-400"><Check className="w-3 h-3" /> {SPEICHER_TEXT.gespeichert}</span>;
  }
  if (anzeige === 'unvollstaendig') {
    return (
      <span className="inline-flex items-start gap-1 text-[11px] font-semibold text-amber-700">
        <AlertTriangle className="w-3 h-3 shrink-0 mt-px" /> {SPEICHER_TEXT.unvollstaendig}{gruende && gruende.length ? `: ${gruende.join(' ')}` : ''}
      </span>
    );
  }
  return (
    <span className="inline-flex flex-wrap items-center gap-1.5 text-[11px] font-bold text-red-700">
      <AlertTriangle className="w-3 h-3 shrink-0" />
      {onErneut ? (
        <button type="button" onClick={onErneut} className="inline-flex items-center gap-1 underline"><RotateCw className="w-3 h-3" /> {SPEICHER_TEXT.fehler}</button>
      ) : SPEICHER_TEXT.fehler}
      {fehler && <span className="font-normal">({fehler})</span>}
      {onNeuLaden && <button type="button" onClick={onNeuLaden} className="font-semibold underline">Neu laden</button>}
    </span>
  );
};
